import { Dispatch } from 'redux';
import { AUTH_TOKEN_KEY } from '../constants/base';
import { ApiAuth } from '../http';
import { authActions } from '../slices/auth-slice';

const {
  setLoginRequired,
  setLoginRequest,
  setLoginSuccess,
  setLoginFailure,
  setLogout,
  setUserRequest,
  setUserSuccess,
  setUserFailure,
  setUserDefault,
} = authActions;

const persistAuthToken = (token: string) => localStorage.setItem(AUTH_TOKEN_KEY, token);
const removeAuthToken = () => localStorage.removeItem(AUTH_TOKEN_KEY);

export const authLogin = (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setLoginRequest());
  try {
    const { accessToken } = await ApiAuth.auth(data);
    persistAuthToken(accessToken);
    dispatch(setLoginSuccess());
    dispatch(getOwner());
  } catch ({ message }) {
    dispatch(setLoginFailure({ message }));
  }
};

export const authCode = (code: string) => async (dispatch: Dispatch<any>) => {
  dispatch(setLoginRequest());
  return new Promise((resolve, reject) => {
    ApiAuth.code({ code })
      .then((res) => {
        persistAuthToken(res.accessToken);
        dispatch(setLoginSuccess());
        dispatch(getOwner());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setLoginFailure({ message: res.message }));
        reject(res);
      });
  });
};

export const authLogout = () => async (dispatch: Dispatch<any>) => {
  removeAuthToken();
  dispatch(setLogout());
  dispatch(setUserDefault());
};

export const authRestore = () => (dispatch: Dispatch<any>) => {
  if (localStorage.getItem(AUTH_TOKEN_KEY)) {
    dispatch(setLoginSuccess());
    dispatch(getOwner());
  }
  dispatch(setLoginRequired(false));
};

export const getOwner = () => async (dispatch: Dispatch<any>) => {
  dispatch(setUserRequest());
  try {
    const res = await ApiAuth.me();
    dispatch(setUserSuccess(res));
  } catch ({ message }) {
    dispatch(setUserFailure(message));
    dispatch(authLogout());
  }
};
export const getOwnerUpdate = () => async (dispatch: Dispatch<any>) => {
  dispatch(setUserRequest());
  try {
    const res = await ApiAuth.meUpdate();
    dispatch(setUserSuccess(res));
  } catch ({ message }) {
    dispatch(setUserFailure(message));
    dispatch(authLogout());
  }
};
